<template>
   <section class="payment-box">
      <slot />
   </section>
</template>

<script>
export default {
  name: 'PaymentBox'
};
</script>

<style lang="scss" scoped>
   .payment-box {
      background: #F7F7F8;
      width: 100%;
      height: 100%;
      min-height: 100vh;
      padding: 32px 16px;
   }
</style>
